module.exports = __webpack_public_path__ + "static/media/no-data-found.6b7ddc63.webp";